<core-dynamic-component [component]="componentClass" [data]="data" />
